import { Logo } from "@/frontend/shared/ui/Logo";
import { Tag } from "@/frontend/shared/ui/Tag";
import { Typography } from "@/frontend/shared/ui/Typography/Typography";
import styles from "./CompanyCell.module.scss";
import clsx from "clsx";
import { TCompany, TTableCompany } from "@/frontend/features/Company/model/types/types";

export function CompanyCell({ field, isFounder }: { field: TTableCompany; isFounder?: boolean }) {
  const { name, headline, logoUrl } = field;

  return (
    <div className={clsx(styles.company, isFounder && styles.isFounderCompany)}>
      <div className={styles.companyInfo}>
        <Logo logo={logoUrl || ""} alt="logo" />
        <div className={styles.companyShortInfo}>
          <Typography variant="label-3" color="greyscale900">
            {name}
          </Typography>
          <Typography variant="body-3" color="greyscale700" className={styles.descriptionField}>
            {headline}
          </Typography>
        </div>
      </div>
    </div>
  );
}
